import { render, staticRenderFns } from "./ApplicantMessageRegisterConfirm.vue?vue&type=template&id=8c09c828"
import script from "./ApplicantMessageRegisterConfirm.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageRegisterConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports